function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import fetch from 'isomorphic-fetch';
/**
 * Functions for requests to backend API
 * @param {String} url url to backend API
 * @param {String} method request method
 * @param {Object} body Body with needed data for POST request
 * @returns {Object} object with response and body data
 */

function request(_x, _x2) {
  return _request.apply(this, arguments);
}
/**
* GET API call for recover password by email
* @param {String} apiUrl url to backend API
* @param {String} email user email
* @param {String} token Google ReCaptcha response token
* @return {Promise} return promise
*/

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(url, method) {
    var body,
      opts,
      res,
      parsedBody,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            opts = {
              method: method
            };
            if (method === 'POST') {
              opts.headers = {
                'Content-Type': 'application/json'
              };
              opts.body = JSON.stringify(body);
            }
            _context.prev = 3;
            _context.next = 6;
            return fetch(url, opts);
          case 6:
            res = _context.sent;
            _context.next = 9;
            return res.json();
          case 9:
            parsedBody = _context.sent;
            return _context.abrupt("return", {
              res: res,
              body: parsedBody
            });
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);
            throw new Error("Failed fetch '".concat(method, "' '").concat(url, "'").concat(body !== null ? " with body '".concat(JSON.stringify(body), "'") : '', ": ").concat(_context.t0.stack));
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 13]]);
  }));
  return _request.apply(this, arguments);
}
export function recoverPasswordByEmail(_x3, _x4, _x5) {
  return _recoverPasswordByEmail.apply(this, arguments);
}
/**
 * GET API call for recover password by phone number
* @param {String} apiUrl url to backend API
* @param {String} phoneNumber user email
* @param {String} token Google ReCaptcha response token
* @return {Promise} return promise
*/

function _recoverPasswordByEmail() {
  _recoverPasswordByEmail = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(apiUrl, email, token) {
    var url;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = !!token ? "".concat(apiUrl, "/email/").concat(email, "?responseToken=").concat(token) : "".concat(apiUrl, "/email/").concat(email);
            return _context2.abrupt("return", request(url, 'GET'));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _recoverPasswordByEmail.apply(this, arguments);
}
export function recoverPasswordByPhone(apiUrl, phoneNumber, token) {
  var url = !!token ? "".concat(apiUrl, "/phone/").concat(phoneNumber, "?responseToken=").concat(token) : "".concat(apiUrl, "/phone/").concat(phoneNumber);
  return request(url, 'GET');
}
/**
* POST API call for save password
* @param {String} apiUrl url to backend API
* @param {String} token token for API
* @param {String} password new password
* @return {Promise} return promise
*/

export function savePassword(apiUrl, token, password) {
  return request("".concat(apiUrl, "/save-password"), 'POST', {
    token: token,
    password: password
  });
}
/**
* POST API call for check recover code validity
* @param {String} apiUrl url to backend API
* @param {String} token recover token
* @param {String} recoveryCode recover code
* @return {Promise} return promise
*/

export function validateRecoveryCode(_x6, _x7, _x8) {
  return _validateRecoveryCode.apply(this, arguments);
}
function _validateRecoveryCode() {
  _validateRecoveryCode = _asyncToGenerator( /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(apiUrl, token, recoveryCode) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", request("".concat(apiUrl, "/validate-code"), 'POST', {
              token: token,
              recoveryCode: recoveryCode
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _validateRecoveryCode.apply(this, arguments);
}